import { FC } from 'react';

interface NavbarListProps {
  isOpen: boolean;
  children?: React.ReactNode;  
}

export const NavbarList: FC<NavbarListProps> = ({isOpen, children}) => {
  return (
    <>
      {/* Dropdown Menu (visible when hamburger is clicked) */}
      <ul
        className={`${isOpen ? "block" : "hidden"} bg-primary-default absolute w-full left-0 top-18 md:top-24 lg:static lg:flex lg:justify-end lg:space-x-2 items-center`}
      >
        {children}
      </ul>
    </>
  );
}